import { PluginObject } from "vue";
import commonMessages from "@/validations/messages";
import datePicker from "@/plugins/components/datePicker/datePicker";
import { titleCase } from '@/services/filters/titleCase';
let commonPlugin: PluginObject<{}> = {
  install(Vue) {
    Vue.prototype.$errorMessages = commonMessages;
    Vue.component("datePicker", datePicker);
    Vue.filter("titleCase",titleCase);
  }
};

export default commonPlugin;
